import { getRangeStyles } from './getSelectedStyle.js';

const getBasicStyles = (theme, hasFooter, isInline) => {
    return `
    > * {
      user-select: none;
    }

    .react-datepicker {
      font-family: 'opensans-regular', serif;
      font-size: 12px;
      font-weight: 400;
      line-height: 1;
      border: none;
      box-shadow: ${isInline ? 'unset' : `0 4px 32px 0 ${theme.palette.dropShadow.main}`};
      border-radius: ${hasFooter ? '4px 4px 0 0' : '4px'};
      ${hasFooter && 'min-height: 324px'};
    }

    .react-datepicker-popper {
      z-index: 10000;
    }

    .react-datepicker-wrapper,
    .react-datepicker__input-container,
    .react-datepicker__input-container input {
      width: auto;
    }

    .react-datepicker__day-names {
      margin: ${theme.spacing(4)};
    }

    .react-datepicker__day-name {
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.2px;
      text-transform: uppercase;
      line-height: 1;
      height: 12px;
      width: 32px;
      color: ${theme.palette.N30.main};
      margin: ${theme.spacing(0, 1, 0, 0)};
      :last-of-type {
        margin: 0;
      }
    }

    .react-datepicker,
    .react-datepicker__header {
      background-color: ${theme.palette.N60.main};
    }

    .react-datepicker__header {
      padding: 0;
      border-bottom: none;
    }

    .react-datepicker__month {
      margin: ${theme.spacing(0, 4)};
    }

    .react-datepicker__week {
      display: flex;
      height: 32px;
      margin: ${theme.spacing(0, 0, 1, 0)};
      :last-of-type {
        margin-bottom: ${theme.spacing(4)};
      }
    }

    .react-datepicker__day {
      align-items: center;
      justify-content: center;
      display: flex;
      background-color: transparent;
      position: relative;
      margin: ${theme.spacing(0, 1, 0, 0)};
      width: 32px;
      height: 32px;
      color: ${theme.palette.common.white};
      font-size: 12px;
      font-weight: 400;
      border-radius: 0;
      :focus-visible {
        outline: none;
      }
      :hover {
        background-color: transparent;
        border-radius: inherit;
      }
      :last-of-type {
        border-top-right-radius: 50%;
        border-bottom-right-radius: 50%;
        margin: 0;
      }
      :first-of-type {
        border-top-left-radius: 50%;
        border-bottom-left-radius: 50%;
        :after {
          display: none;
        }
      }
    }

    .react-datepicker__day--outside-month {
      pointer-events: none;
      opacity: 0;
      :after {
        display: none;
      }
    }

    .react-datepicker__day--in-range,
    .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--outside-month) {
      ${getRangeStyles(theme)};
    }
  `;
};

export { getBasicStyles as default };
//# sourceMappingURL=getBasicStyles.js.map
